import { takeEvery, put, call, all } from "redux-saga/effects";
import apiCall from "../services";

const apiUrl = process.env.REACT_APP_API_URL;
const enviromentUrl = process.env.REACT_APP_ENVIROMENT;

function* getProductInclusionsCategory(actions) {
  let uuid = getSetCookie();

  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url = apiUrl + "/opa-product-inclusion/" + actions.productUuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "GET", url, requestOptions);
    yield put({ type: "LIST_PRODUCT_INCLUSIONS_CATEGORY_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "LIST_PRODUCT_INCLUSIONS_CATEGORY_RESPONSE_GET", value: error });
  }
}

function* deleteProductInclusionsCategory(actions) {
  let uuid = getSetCookie();

  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url = apiUrl + "/opa-product-inclusion/" + actions.productUuid + "/" + actions.inclusionCategoryUuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "DELETE", url, requestOptions);


    let responseStatus = "warning";
    if (response) {
      if (response.status === 200) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({ type: "DELETE_PRODUCT_INCLUSIONS_CATEGORY_RESPONSE_GET", value: { ...response, responseStatus } });
  } catch (error) {
    yield put({ type: "DELETE_PRODUCT_INCLUSIONS_CATEGORY_RESPONSE_GET", value: { ...error, responseStatus: "error" } });
  }
}

function* getInclusionsCategory(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      actions.query !== undefined
        ? apiUrl + "/opa-inclusion-categories" + actions.query
        : actions.page !== undefined
          ? apiUrl + "/opa-inclusion-categories" + actions.page
          : apiUrl + "/opa-inclusion-categories";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({ type: "LIST_INCLUSIONS_CATEGORY_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "LIST_INCLUSIONS_CATEGORY_RESPONSE_GET", value: error });
  }
}

function* updateProductInclusionsCategory(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-product-inclusion/" + actions.productUuid + "/" + actions.inclusionCategoryUuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "PATCH", url, requestOptions);


    let responseStatus = "warning";

    if (response) {
      if (response.createdAt) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({ type: "UPDATE_PRODUCT_INCLUSIONS_CATEGORY_RESPONSE", value: { ...response, responseStatus } });

    return response;
  } catch (error) {
    yield put({ type: "UPDATE_PRODUCT_INCLUSIONS_CATEGORY_RESPONSE", value: { ...error, responseStatus: "error" } });
    throw error;
  }
}

function* createInclusionsCategory(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-product-inclusion/" + actions.productUuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    let responseStatus = "warning";

    if (response) {
      if (response.createdAt) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({ type: "CREATE_INCLUSIONS_CATEGORY_RESPONSE", value: { ...response, responseStatus } });

    return response;
  } catch (error) {
    yield put({ type: "CREATE_INCLUSIONS_CATEGORY_RESPONSE", value: { ...error, responseStatus: "error" } });
    throw error;
  }
}

export function* getSagaProductInclusionsCategoryList() {
  yield takeEvery("GET_PRODUCT_LIST_INCLUSIONS_CATEGORY", getProductInclusionsCategory);
}

export function* deleteSagaProductInclusionsCategory() {
  yield takeEvery("DELETE_PRODUCT_INCLUSIONS_CATEGORY", deleteProductInclusionsCategory);
}

export function* updateSagaProductInclusionsCategory() {
  yield takeEvery("UPDATE_PRODUCT_INCLUSIONS_CATEGORY", updateProductInclusionsCategory);
}

export function* getSagaInclusionsCategoryList() {
  yield takeEvery("GET_LIST_INCLUSIONS_CATEGORY", getInclusionsCategory);
}

export function* createSagaInclusionsCategory() {
  yield takeEvery("CREATE_INCLUSIONS_CATEGORY", createInclusionsCategory);
}

const getSetCookie = () => {
  return window.localStorage.getItem("uuidSetCookie");
};
